import React, { useState } from "react";
import { AddNewCategory } from "../../pages";
import * as yup from "yup";
import BusinessCategoryController from "../../controllers/BusinessCategoryController";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";

const AddNewCategoryContainer = ({ closeModal, data }) => {
  const [loading, setLoading] = useState(false);
  const validationSchema = () => {
    return yup.object().shape({
      name: yup.string().required("Enter category name"),
      description: yup.string().required("Enter category description"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      name: values.name,
      description: values.description,
    };
    const { status, errorMessage } =
      await BusinessCategoryController.createBusinessCategories(payload);

    if (status === constant.Success) {
      MimaToastUtil.success({ message: constant.Success });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };
  return (
    <AddNewCategory
      validationSchema={validationSchema}
      loading={loading}
      closeModal={closeModal}
      data={data}
      onSubmit={onSubmit}
    />
  );
};
export default AddNewCategoryContainer;
